import { NavLink, Outlet, useLocation } from 'react-router-dom'

import { Badge } from '@/components/ui/Badge'

const NAV = [
  { to: '/query', label: '设备查询', hint: '物料判定 + AI 问答', end: false },
  { to: '/status', label: '服务状态', hint: '后端与配置', end: false },
]

export function AppShell() {
  const { pathname } = useLocation()
  const current = NAV.find((item) => pathname.startsWith(item.to))

  return (
    <div className="flex h-full">
      <aside className="hidden w-56 shrink-0 flex-col bg-brand-900 text-white lg:flex">
        <div className="flex items-baseline gap-2 px-5 py-5">
          <span className="text-lg font-semibold tracking-wide">寻料</span>
          <span className="text-xs text-brand-200">采购设备平台</span>
        </div>
        <nav className="flex flex-col gap-1 px-3">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-control px-3 py-2 transition-colors ${
                  isActive ? 'bg-brand-700 text-white' : 'text-brand-200 hover:bg-brand-800 hover:text-white'
                }`
              }
            >
              <span className="block text-sm font-medium">{item.label}</span>
              <span className="block text-[11px] text-brand-300">{item.hint}</span>
            </NavLink>
          ))}
        </nav>
        <p className="mt-auto px-5 py-4 text-[11px] leading-relaxed text-brand-300">
          工厂内部使用
          <br />
          设备参数与价格以合同为准
        </p>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="border-b border-line bg-surface">
          <div className="flex h-14 items-center justify-between gap-3 px-4 sm:px-6">
            <div className="min-w-0">
              <h1 className="truncate text-[15px] font-semibold text-brand-900">{current?.label ?? '寻料'}</h1>
              <p className="truncate text-xs text-muted">{current?.hint ?? '设备信息查询'}</p>
            </div>
            <Badge tone="brand">规则引擎已接入 · 联网取料（无密钥回退快照）</Badge>
          </div>
          <nav className="flex gap-1 px-3 pb-2 lg:hidden">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-control px-3 py-1.5 text-sm ${
                    isActive ? 'bg-brand-600 text-white' : 'text-muted hover:bg-brand-50'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </header>

        <main className="min-h-0 flex-1 overflow-auto bg-canvas p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
